'use client'

import { LEFT_QUOTE, RIGHT_QUOTE } from '@/components/RevampedLanding/contants'
import { FounderSectionProps } from '@/widgets/landing-page-widgets/FounderSection/schema'
import { cn, Typography } from '@pw-tech/omni-ui'
import { useInView } from 'framer-motion'
import Image from 'next/image'
import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'

const FounderSection = ({ founderSectionData }: { founderSectionData: FounderSectionProps }) => {
  const [isFounderSectionInView, setIsFounderSectionInView] = useState(false)
  const founderSectionRef = React.useRef<HTMLDivElement>(null)
  const isFounderInView = useInView(founderSectionRef, { amount: 0.1 })

  useEffect(() => {
    if (isFounderInView && !isFounderSectionInView) {
      setIsFounderSectionInView(true)
    }
  }, [isFounderInView, isFounderSectionInView])

  return (
    <div className="w-full overflow-hidden" ref={founderSectionRef}>
      <div
        className="lg:py-[60px] pt-6 flex lg:flex-row flex-col overflow-y-hidden relative overflow-x-visible"
        style={{
          background:
            'radial-gradient(50% 50% at 50% 50%, rgba(255, 221, 198, 0.3) 0%, rgba(255, 255, 255, 0.3) 98.5%)',
        }}
      >
        <div className="xl:w-[72rem] md:w-full relative mx-auto px-4 md:px-6">
          <div
            className={cn('flex flex-col gap-4 md:gap-8 md:max-w-[calc(72rem-500px)]', {
              [styles.founder_left_section]: isFounderSectionInView,
            })}
          >
            <Typography variant='heading2' weight='bold' color='#1b2124'>
              {founderSectionData?.founderSection?.heading}
            </Typography>

            <div className="flex flex-col gap-2 md:gap-3">
              <div className="self-start w-6 h-4 md:w-7 md:h-5 relative">
                <Image src={LEFT_QUOTE} layout='fill' alt='left-quote-image' loading='lazy' />
              </div>
              <Typography variant='heading4' weight='medium' color='#3d3d3d'>
                {founderSectionData?.founderSection?.founderMessage}
              </Typography>
              <div className={cn('self-start w-6 h-4 md:w-7 md:h-5 relative', 'self-end')}>
                <Image src={RIGHT_QUOTE} layout='fill' alt='right-quote-image' loading='lazy' />
              </div>
            </div>

            <div className="flex flex-col gap-1 md:gap-2">
              <Typography variant='heading3' weight='bold' color='#1b2124'>
                {founderSectionData?.founderSection?.founderName}
              </Typography>
              <Typography variant='regular' color='#1b2124'>
                {founderSectionData?.founderSection?.founderDesignation}
              </Typography>
            </div>
          </div>

          <div
            className={cn('lg:absolute lg:max-h-[470px] lg:max-w-[360px] max-w-[200px] md:-bottom-24 -bottom-8 right-0 mx-auto relative', {
              [styles.founder_right_section]: isFounderSectionInView,
            })}
          >
            <Image
              alt='Founder Image'
              src={founderSectionData?.founderSection?.founderImage}
              layout='intrinsic'
              width={400}
              height={538}
              loading='lazy'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FounderSection
